import { render, staticRenderFns } from "./PromotionalPricingImport.vue?vue&type=template&id=daab9ca2"
import script from "./PromotionalPricingImport.vue?vue&type=script&lang=js"
export * from "./PromotionalPricingImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports